import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const Landing = () => {
  const location = useLocation();
  const [message, setMessage] = useState({ title: '', body: '', type: '' });

  useEffect(() => {
    // Extract query parameters from URL
    const searchParams = new URLSearchParams(location.search);
    const result = searchParams.get('result') || '';
    const resultDescription = searchParams.get('result-description') || '';
    const service = searchParams.get('service') || '';

    // Determine message based on result and result-description
    if (result === 'Completed' && resultDescription === 'SuccessfullySubscribed') {
      setMessage({
        title: 'Congratulations!',
        body: 'You have successfully subscribed to Lynx LifeStyle Club! Log in now to enjoy unlimited content and a chance to win airtime prizes!',
        type: 'success'
      });
    } else if (result === '7' && resultDescription === 'ExistingSubscription') {
      setMessage({
        title: 'Welcome Back!',
        body: 'You are already a subscriber to Lynx LifeStyle Club! Log in to continue enjoying your benefits.',
        type: 'success'
      });
    } else if (result === 'Fraud' && resultDescription === 'FraudDetected') {
      setMessage({
        title: 'Action Required',
        body: 'Fraud was detected. Please contact support at Info@lynxlife.club or call 0109003333 for assistance.',
        type: 'error'
      });
    } else if (result === '22' && resultDescription === 'DUPLICATE PROMO CODE') {
      setMessage({
        title: 'Duplicate Promo Code',
        body: 'The promo code you used has already been redeemed. Log in to continue or contact support.',
        type: 'success'
      });
    } else if (result === '21' && resultDescription === 'PAYMENT FAILED') {
      setMessage({
        title: 'Payment Issue',
        body: 'You did not have enough funds to complete the subscription. Please ensure sufficient balance and try again.',
        type: 'error'
      });
    } else if (result === '500' && resultDescription === 'ErrorOccurred') {
      setMessage({
        title: 'Technical Error',
        body: 'An unexpected error occurred. Please try again later or contact support at Info@lynxlife.club.',
        type: 'error'
      });
    } else if (result === '423') {
      setMessage({
        title: 'Content Block',
        body: `Your request to ${service || 'this service'} has been rejected due to the Content Block set on your Vodacom number. Please contact your Vodacom Administrator.`,
        type: 'error'
      });
    } else {
      setMessage({
        title: 'Unknown Status',
        body: 'We couldnt process your request. Please try again or contact support at Info@lynxlife.club.',
        type: 'error'
      });
    }
  }, [location.search]);

  return (
    <div className="container-fluid viewport fun-background">
      <section className="text-center text-lg-start">
        <div className="container">
          <div className="row g-0 align-items-center">
            <div className="col-lg-6 mb-5 mb-lg-0">
              <div className="lynx_darkcards_noborder cascading-right img_bootstrap">
                <div className="p-5 text-center">
                  <h2 className="text-lynx fw-bold">🐾 Lynx LifeStyle Club</h2>
                  <div className="form-outline">
                    <div className="lynx_opacity_text text-center">
                      <h1>{message.title}</h1>
                      <br />
                      <p>{message.body}</p>
                      {message.type === 'success' && (
                        <div className="d-grid gap-2">
                          <Link to="/login" className="btn-lynx">
                            🚀 Log In Now
                          </Link>
                        </div>
                      )}
                      <br />
                      <br />
                      <br />
                      Thousands of Rands awarded already. Don't miss out on your chance to win!
                      <br />
                      <small>
                        R7 per day, T&Cs apply. To unsubscribe dial *135*997#
                        <br />
                        <Link className="lynx_opacity_text btn nav-link" to="/Terms?md=7">Terms</Link>
                        <br />
                        Info@lynxlife.club
                        <br />
                        0109003333 (std rates apply)
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 mb-5 mb-lg-0 container-fluid lynx_m_img d-flex justify-content-center">
              <img src="mascot.png" className="mascot-img lynx_m_img" alt="" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Landing;
